/**
 * Defaults para Cards
 */

export const cardDefaults: Record<string, Record<string, unknown> | undefined> = {
  VCard: {
    elevation: 2,
    rounded: 'lg',
    VBtn: {
      variant: 'text',
      style: [{ textTransform: 'none' }],
    },
  },

  VCardElevated: {
    elevation: 4,
    rounded: 'lg',
  },

  VCardOutlined: {
    elevation: 0,
    variant: 'outlined',
    rounded: 'lg',
  },

  VCardFlat: {
    elevation: 0,
    variant: 'flat',
    rounded: 'lg',
  },

  VCardTitle: {
    style: [{
      fontSize: '1.25rem',
      fontWeight: 600,
      color: 'rgb(var(--v-theme-gray-950))',
    }],
  },

  VCardSubtitle: {
    style: [{
      fontSize: '0.875rem',
      color: 'rgb(var(--v-theme-gray-600))',
    }],
  },

  VCardActions: {
    style: [{ padding: '16px' }],
  },
}
